import React from "react";

export const PlusIcon = ({ nameOfClass, handleClick, value = null }) => {
    return <svg className={nameOfClass} onClick={() => handleClick(value)} viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.80769 1.23077C9.80769 0.55 9.22332 0 8.5 0C7.77668 0 7.19231 0.55 7.19231 1.23077V6.76923H1.30769C0.584375 6.76923 0 7.31923 0 8C0 8.68077 0.584375 9.23077 1.30769 9.23077H7.19231V14.7692C7.19231 15.45 7.77668 16 8.5 16C9.22332 16 9.80769 15.45 9.80769 14.7692V9.23077H15.6923C16.4156 9.23077 17 8.68077 17 8C17 7.31923 16.4156 6.76923 15.6923 6.76923H9.80769V1.23077Z"/>
    </svg>;
};
